import { BaseTermSelectorComponent } from 'pricing-pages-ui-components/components/merch-card/terms-display/BaseTermSelectorComponent';
import { useCallback, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function toBaseTermValue(term) {
  if (term === 'ANNUAL' || term === 'MONTHLY') return term;
  return null;
}
export const PublicTermSelector = ({
  selectedTerm,
  onTermChange,
  availableTerms,
  discountPercentage = 0,
  dataSeleniumId = 'public-term-selector'
}) => {
  const baseAvailableTerms = useMemo(() => {
    const annual = availableTerms['ANNUAL'];
    const monthly = availableTerms['MONTHLY'];
    if (!annual || !monthly) return undefined;
    return {
      annual: {
        commitment: toBaseTermValue(annual.commitmentTerm),
        payment: toBaseTermValue(annual.paymentTerm)
      },
      monthly: {
        commitment: toBaseTermValue(monthly.commitmentTerm),
        payment: toBaseTermValue(monthly.paymentTerm)
      }
    };
  }, [availableTerms]);
  const handleToggleChange = useCallback(() => {
    const nextTerm = selectedTerm === 'ANNUAL' ? 'MONTHLY' : 'ANNUAL';
    onTermChange(nextTerm);
  }, [selectedTerm, onTermChange]);
  const activeTerm = selectedTerm === 'MONTHLY' ? 'MONTHLY' : 'ANNUAL';
  return /*#__PURE__*/_jsx(BaseTermSelectorComponent, {
    onToggleChange: handleToggleChange,
    activeTerm: activeTerm,
    availableTerms: baseAvailableTerms,
    hasAnnualDiscount: discountPercentage > 0,
    dataSeleniumId: dataSeleniumId
  });
};